import { gql } from "@apollo/client";


export const GET_CUSTOMER_CASE_STUDY = gql`
query getCustomerCaseStudy($filters: CustomerFiltersInput) {
    customers(filters: $filters) {
      data {
        attributes {
          company
          logo {
            data {
              attributes {
                url
                width
                height
              }
            }
          }
          caseStudy {
            
            ... on ComponentCasestudyIntro {  
              title
              content          
            }
            ... on ComponentCasestudyChallenge {
              title
              content
            }
          ... on ComponentCasestudyApproach {
            title
            content
          }
            ...on ComponentCasestudyBenefits {
              title
              content
            }
            
          }
        }
      }
    }
  }
`